var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsset189(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 118.59 118.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d5dfeb;}.cls-2{fill:#2f55d4;opacity:0.15;}.cls-3{fill:#fff;}.cls-4{fill:#c6bbff;}.cls-5{fill:#ff8dd9;}.cls-6{fill:#3e6177;}.cls-7{fill:#2f55d4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 189") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 110.99,
    cy: 21.82,
    r: 2.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -14.21,
    y: 34.29,
    width: 147,
    height: 50,
    rx: 25,
    ry: 25,
    transform: "translate(-24.56 59.29) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M103.11,30.25V32.3a96.57,96.57,0,0,1-2.82,24.16c-.07.28-.14.55-.22.82A67.23,67.23,0,0,1,96,68.41l-.33.69c-.61,1.26-1.27,2.51-2,3.72l-.1.17-.39.65a53.9,53.9,0,0,1-6.91,9.15A49.18,49.18,0,0,1,80,88.4C78,90,75.26,91.08,74.3,93.7a8.74,8.74,0,0,0-.06,6.39c1.25,2.68,4.72,3.21,7.29,3.76s7.05,1.4,5.81,5c-.71,2.07-3,2.18-4.89,2.18H49.18c-1.85,0-4.18-.11-4.89-2.18a3.53,3.53,0,0,1-.18-.76h0c-.41-3,3.65-3.78,6-4.29,2.57-.55,6-1.08,7.29-3.76A6.49,6.49,0,0,0,58,97.64v0a10.21,10.21,0,0,0-.62-3.92c-1-2.62-3.65-3.73-5.74-5.3a49.18,49.18,0,0,1-6.26-5.61,53.9,53.9,0,0,1-6.91-9.15L38,73l-.1-.17c-.71-1.22-1.37-2.46-2-3.72l-.33-.69a67.23,67.23,0,0,1-4.05-11.13c-.07-.27-.15-.55-.22-.82A96.57,96.57,0,0,1,28.53,32.3V30.25a7.31,7.31,0,0,1,7.31-7.31h60A7.31,7.31,0,0,1,103.11,30.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.16,107.8a5,5,0,0,0,5-5.33c-.25-3.65-1.08-7.49.48-11,1.67-3.72,5.32-5.93,8.24-8.57,13.91-12.58,17.73-31.3,18.51-49.17.12-2.8-.94-5.65-4.28-5.65H33.29a2.9,2.9,0,0,0-2.92,3.14,99.64,99.64,0,0,0,7.92,33.4,58.46,58.46,0,0,0,8.29,13.68c2.92,3.52,7,6,10.06,9.51,4.09,4.64,3.73,9.15,3.12,15-.25,2.4.65,5,3.53,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M61.09,107.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M48,101.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M81.46,112.57H48.18c-1.69,0-5.21,0-6.3-3.19a5.08,5.08,0,0,1-.25-1.06v-.09c-.48-4.2,4.52-5.28,6.94-5.8l.84-.18c2.25-.47,4.8-1,5.63-2.8a5,5,0,0,0,.43-1.88,8.76,8.76,0,0,0-.54-3.36c-.55-1.51-2-2.46-3.54-3.46-.56-.36-1.14-.74-1.69-1.15a50.73,50.73,0,0,1-6.45-5.78,55.39,55.39,0,0,1-7.11-9.4l-.39-.67L37,72.89l-1.29.77-.05-.09c-.71-1.23-1.4-2.51-2-3.82l-.06-.12-.28-.6a68.85,68.85,0,0,1-4.14-11.36c-.08-.27-.15-.56-.22-.84A98.21,98.21,0,0,1,26,32.3V30.25a8.82,8.82,0,0,1,8.81-8.81h60a8.82,8.82,0,0,1,8.81,8.81V32.3a98.27,98.27,0,0,1-2.87,24.54c-.07.28-.15.56-.22.84A69,69,0,0,1,96.38,69l-.33.7c-.63,1.31-1.32,2.59-2,3.82l-.5.84a55.48,55.48,0,0,1-7.11,9.4,50.76,50.76,0,0,1-6.45,5.78c-.55.41-1.13.79-1.69,1.15-1.54,1-3,1.95-3.55,3.46a7.38,7.38,0,0,0-.11,5.24c.84,1.8,3.38,2.33,5.63,2.8l.85.18c2.08.45,5.21,1.12,6.46,3.33a4.29,4.29,0,0,1,.21,3.62C86.67,112.57,83.15,112.57,81.46,112.57Zm-23.27-3H81.46c2.27,0,3.17-.3,3.47-1.16a1.35,1.35,0,0,0,0-1.17c-.58-1-3.12-1.58-4.48-1.87l-.83-.18c-2.65-.55-6.27-1.31-7.74-4.47a10.19,10.19,0,0,1,0-7.53c.89-2.46,2.93-3.78,4.73-5,.52-.34,1-.67,1.52-1a47.8,47.8,0,0,0,6.07-5.44,52.48,52.48,0,0,0,6.72-8.89l.43-.73c.72-1.24,1.37-2.46,2-3.7l.32-.66a66,66,0,0,0,4-10.89c.07-.27.15-.53.21-.8a95.25,95.25,0,0,0,2.77-23.79V30.25a5.81,5.81,0,0,0-5.81-5.81h-60A5.81,5.81,0,0,0,29,30.25V32.3A95.19,95.19,0,0,0,31.8,56.08l.21.8a66,66,0,0,0,4,10.88l.32.68c.6,1.23,1.25,2.45,1.92,3.62l.47.8a52.35,52.35,0,0,0,6.72,8.89,47.73,47.73,0,0,0,6.07,5.44c.48.36,1,.7,1.52,1,1.8,1.17,3.84,2.5,4.73,4.95a11.7,11.7,0,0,1,.71,4.51,8,8,0,0,1-.71,3c-1.47,3.16-5.09,3.92-7.74,4.47l-.83.18c-3,.64-4.76,1.29-4.58,2.57v.1a2.09,2.09,0,0,0,.1.36c.3.88,1.21,1.18,3.47,1.18h10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M74,18.77a5.83,5.83,0,1,1,5.83-5.83A5.84,5.84,0,0,1,74,18.77Zm0-8.66a2.83,2.83,0,1,0,2.83,2.83A2.83,2.83,0,0,0,74,10.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M34.1,91.54a5.83,5.83,0,1,1,5.83-5.83A5.84,5.84,0,0,1,34.1,91.54Zm0-8.66a2.83,2.83,0,1,0,2.83,2.83A2.83,2.83,0,0,0,34.1,82.88Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 102.32,
    cy: 77.26,
    r: 2.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 54.68,
    cy: 13.16,
    r: 2.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 47.75,
    cy: 95.46,
    r: 2.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 69.19,
    y: 32.3,
    width: 12.13,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 83.05,
    y: 32.3,
    width: 5.2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 89.98,
    y: 32.3,
    width: 1.73,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M96.28,69.88H94.74v-3h1.53a9.11,9.11,0,0,0,9.09-9.09,12.07,12.07,0,0,1,3.19-8.19l.78-.85a9.09,9.09,0,0,0-6.69-15.25h-1v-3h1a12.09,12.09,0,0,1,8.9,20.28l-.78.85a9.07,9.07,0,0,0-2.4,6.16A12.11,12.11,0,0,1,96.28,69.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M34.54,69.88H33A12.11,12.11,0,0,1,20.91,57.79a9.07,9.07,0,0,0-2.4-6.16l-.78-.85a12.09,12.09,0,0,1,8.9-20.28h1v3h-1a9.09,9.09,0,0,0-6.69,15.25l.78.85a12.06,12.06,0,0,1,3.19,8.19A9.11,9.11,0,0,0,33,66.88h1.53Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 29.76,
    cy: 33.31,
    r: 25.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 30.63,
    cy: 33.31,
    r: 20.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M29.76,55.1A21.79,21.79,0,1,1,51.56,33.31,21.82,21.82,0,0,1,29.76,55.1Zm0-40.59A18.79,18.79,0,1,0,48.56,33.31,18.82,18.82,0,0,0,29.76,14.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M27.7,42.43a1.92,1.92,0,0,1-1.1-.35l-7.67-5.37a1.5,1.5,0,0,1,1.72-2.46L27.47,39,38.59,24.18A1.5,1.5,0,1,1,41,26L29.24,41.65A1.92,1.92,0,0,1,27.7,42.43Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset189);
export default __webpack_public_path__ + "static/media/Asset189.ef153bb5c04c21137ae00408ced3674d.svg";
export { ForwardRef as ReactComponent };